import React, { useState, useEffect } from 'react';
import { Box, Container, useTheme, useMediaQuery } from '@mui/material';
import ModernNavigation from './ModernNavigation';
import { useBranding } from './BrandingSystem';

const ModernLayout = ({ 
  children, 
  user, 
  onLogout, 
  title = "Sistema de Gestión",
  maxWidth = 'xl',
  disablePadding = false,
  sx = {}
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [themeMode, setThemeMode] = useState('light');
  const { branding } = useBranding();

  useEffect(() => {
    // Load theme mode from localStorage
    const savedThemeMode = localStorage.getItem('themeMode');
    if (savedThemeMode) {
      setThemeMode(savedThemeMode);
    }
  }, []);

  const handleThemeToggle = () => {
    const newMode = themeMode === 'light' ? 'dark' : 'light';
    setThemeMode(newMode);
    localStorage.setItem('themeMode', newMode);
    
    // Force page reload to apply new theme
    window.location.reload();
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    } else {
      // Default logout behavior
      localStorage.removeItem('token');
      localStorage.removeItem('projectId');
      window.location.href = '/';
    }
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <ModernNavigation
        onThemeToggle={handleThemeToggle}
        user={user}
        onLogout={handleLogout}
        title={branding.companyName || title}
      />
      
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          width: { xs: '100%', md: `calc(100% - 280px)` },
          ml: { xs: 0, md: '280px' },
          ...sx,
        }}
      >
        <Container
          maxWidth={maxWidth}
          sx={{
            flex: 1,
            py: disablePadding ? 0 : { xs: 2, md: 4 },
            px: disablePadding ? 0 : { xs: 2, md: 4 },
            mt: { xs: 8, md: 9 }, // Account for AppBar height
          }}
        >
          {children}
        </Container>
      </Box>
    </Box>
  );
};

// Specialized layout variants
export const DashboardLayout = ({ children, ...props }) => (
  <ModernLayout
    maxWidth="xl"
    disablePadding={false}
    {...props}
  >
    {children}
  </ModernLayout>
);

export const FormLayout = ({ children, ...props }) => (
  <ModernLayout
    maxWidth="md"
    disablePadding={false}
    {...props}
  >
    {children}
  </ModernLayout>
);

export const FullWidthLayout = ({ children, ...props }) => (
  <ModernLayout
    maxWidth={false}
    disablePadding={true}
    {...props}
  >
    {children}
  </ModernLayout>
);

export default ModernLayout; 